import { convertSolToLamports } from '../utils/tradeUnits';
import {
  applyFeeReduction,
  estimateBuyTokenAmount,
  getFeeBasisPoints,
  normalizeBigIntValue,
} from './curveMath';

export function getBuyQuote({ globalConfig, currentGameState, solAmount, lamportsIn }) {
  if (!globalConfig || !currentGameState) {
    throw new Error('Live game data is not ready.');
  }

  const inputLamports = lamportsIn ?? convertSolToLamports(solAmount);
  const feeBasisPoints = getFeeBasisPoints(globalConfig);
  const reserveLamportsIn = applyFeeReduction(inputLamports, feeBasisPoints);
  const currentSupplyAtomic = normalizeBigIntValue(currentGameState.current_supply);
  const boostLamports = normalizeBigIntValue(currentGameState.boost);
  const tokenAmountOutAtomic = estimateBuyTokenAmount(currentSupplyAtomic, reserveLamportsIn, boostLamports);

  return {
    feeBasisPoints: feeBasisPoints.toString(),
    lamportsIn: inputLamports.toString(),
    reserveLamportsIn: reserveLamportsIn.toString(),
    tokenAmountOutAtomic: tokenAmountOutAtomic.toString(),
  };
}